import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { trackAddToCartAndRedirect } from '../utils/metaPixel';
export function PricingCTA() {
  const goToCheckout = () => {
    trackAddToCartAndRedirect('https://www.solunetpro.com/cart/46356320452779:1');
  };
  return <section id="pricing-section" className="py-24 relative overflow-hidden" data-id="element-189">
      {/* Red glow background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#ff3366]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-190" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-191">
        <FadeIn data-id="element-192">
          <div className="bg-[#0a0e1a] border border-[#ff3366]/30 rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(255,51,102,0.1)]" data-id="element-193">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-194">
              No necesitas meses de terapia costosa ni libros de 500 páginas.
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-195">
              Necesitas una hoja de ruta que puedas aplicar{' '}
              <strong className="text-white" data-id="element-196">esta misma noche</strong>.
            </p>

            <div className="mb-10" data-id="element-197">
              <div className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-198">
                PAGO ÚNICO
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-199">
                <span className="text-3xl text-gray-500 line-through" data-id="element-200">$97</span>
                <span className="text-6xl md:text-7xl font-extrabold text-white" data-id="element-201">
                  $7<span className="text-2xl text-[#ff3366]" data-id="element-202">.00</span>
                </span>
                <span className="text-xl text-gray-400 mt-4" data-id="element-203">USD</span>
              </div>
              <p className="text-[#ff3366] mt-4 font-medium" data-id="element-204">
                Menos de lo que cuesta una cena que probablemente ni puedas
                comer por la ansiedad.
              </p>
            </div>

            <Button variant="danger" size="lg" fullWidth onClick={goToCheckout} className="max-w-md mx-auto text-lg md:text-xl py-5 animate-pulse-slow shadow-[0_0_30px_rgba(255,51,102,0.4)]" data-id="element-205">
              QUIERO RECUPERAR EL CONTROL AHORA
            </Button>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-400" data-id="element-206">
              <div className="flex items-center gap-2" data-id="element-207">
                <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-208" />
                <span data-id="element-209">Acceso instantáneo tras la compra</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-210">
                <Lock className="w-5 h-5 text-green-400" data-id="element-211" />
                <span data-id="element-212">Tu privacidad está garantizada</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>

      {/* Sticky Mobile CTA (Visible only on small screens when scrolling past hero) */}
      <div className="fixed bottom-0 left-0 w-full p-4 bg-[#0a0e1a]/90 backdrop-blur-md border-t border-white/10 z-50 md:hidden flex justify-center" data-id="element-213">
        <Button variant="danger" fullWidth onClick={goToCheckout} className="shadow-[0_0_15px_rgba(255,51,102,0.5)]" data-id="element-214">
          OBTENER ACCESO POR $7
        </Button>
      </div>
    </section>;
}